<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: blue" icon="newspaper" ></font-awesome-icon>
            <a  class="mainblock-label">试题详情</a>
          </div>
        </div>
        <div class="container-body panel-party" style="display: flex;">
          <div  class="cardContainer">
            <div style="align-self: center">答题卡</div>
            <div class="cardItemContainer">
              <div :class="question.answered?'cardItem answered' : 'cardItem unanswered'" v-for="(question,index) in questionList"  @click="meuns(index+1)" style="cursor: pointer;">{{index+1}}</div>

            </div>
          </div>
          <div class="party-right">
            <div class="dataContent" id="dataContent">
              <div v-for="(question,index) in questionList2" class="questionItem" :id="'question_'+ ((page-1)*pageSize+index)">
                <div class="questionRow">
                  <div class="type" v-if="question.questionType == 1" style="color: green"> （判断题）</div>
                  <div class="type" v-if="question.questionType == 2" style="color: blue"> （单选题）</div>
                  <div class="type" v-if="question.questionType == 3" style="color: darkblue"> （多选题）</div>
                  <div>{{(page-1)*pageSize+index+1}}、</div>
                  <div class="questionContent" v-html="question.questionContent"></div>
                </div>

                <div  v-for="answer in question.answerList"
                        class="answerContainer">
                  <div @click="toChooseAnswer(question,answer,index)"
                  :class="answer.selected?'answer-choose':'answer-bg'"
                   v-if="question.questionType>1"
                  v-html="answer.optionName"></div>
                    <div class="answerContent" v-if="question.questionType>1" v-html="answer.answerContent"></div>

                <div @click="toChooseAnswer(question,answer,index)"
                     :class="answer.selected?'answer-choose':'answer-bg'"
                     v-if="question.questionType==1"
                     v-html="answer.showName"></div>
                <div class="answerContent" v-if="question.questionType==1" v-html="answer.answerContent"></div>
              </div>
              </div>

            </div>
          </div>
          <div class="buttonContainer" v-show="isLimitIp">
            <div>剩余时间</div>
            <div class="restTime">{{testTimeTxt}}</div>
            <div class="restTime">第{{page}}页,共{{totalPage}}页</div>
            <el-button class="submitButton" type="success" @click="clickPre"> 上一页</el-button><br/><br/>
            <el-button class="submitButton" type="success" @click="clickNext"> 下一页</el-button><br/><br/>
            <el-button class="submitButton" type="primary" @click="clickSubmit"> 交卷</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped >
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
  .cardContainer{
    width: 18%;
    display: flex;
    flex-direction: column;
    background: white;
    align-items: center;
  }
  .cardItemContainer{
    display: grid;
    grid-template-columns: repeat(auto-fill,40px);
    width: 80%;
    justify-content: space-around;
  }
  .cardItem{
    width: 40px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .answered{
    border: 1px #409EFF solid;
    border-radius: 5px;
    background: #409EFF;
    color: white;
  }

  .unanswered{
    border: 1px gray solid;
    border-radius: 5px;
    color: gray;
    background: white;
  }
  .panel-party{
    display: flex;
    padding: 0;
  }
  .container-body{
    display: flex;
    justify-content: space-between;
    background: #f4f4f4;
  }
  .container-head{
    justify-content: space-between;
  }
  .buttonContainer{
    width: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
  }
  .submitButton{
    align-self: end;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-right: 2rem;
  }
  .answer-bg{
    margin-left: 20px;
    word-wrap:break-word;
    border: 1px #616161 solid;
    border-radius: 4px;
    background: #fafafa;
    color: #616161;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .answerContainer{
    display: flex;
    margin-top: 20px;
  }
  .answerContent{
    margin-left: 10px;
    display: flex;
    align-items: center;
    min-height: 30px;
  }
  .answer-choose{
    width: 30px;
    height: 30px;
    margin-left: 20px;
    word-wrap:break-word;
    border: 1px #409EFF solid;
    border-radius: 15px;
    background: #409EFF;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .questionContent{
    width: 1000px;
    float:left;
    text-overflow:ellipsis;
    overflow:hidden;
  }
  p{
    text-align: start;
    margin: 0 auto;
    word-wrap:break-word;

  }
  .party-right{
    margin-left: 0px;
    width: 70%;
    background: white;
  }
  .dataContent{
    height: 800px;
    overflow-y: auto;
  }
  .questionItem{
    display: flex;
    flex-direction: column;
  }
  .questionItem + .questionItem{
    margin-top: 20px;
  }
  .answerInfo {
    margin-top: 10px;
    margin-left: 20px;
    word-wrap:break-word;
  }
  .questionRow{
    display: flex;
  }
  .type{
    min-width: 80px;
  }
  .solution{
    margin-top: 10px;
    margin-left: 20px;
  }
  .restTime{
    color: #fe0000;
    font-size: 15px;
    margin-top: 20px;
    margin-bottom: 30px;
  }
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters ,mapMutations} from 'vuex'
  import CryptoJS from 'crypto-js'
  const moment = require('moment')
  export default {
    name: 'Training',
    inject:['check'],
    data(){
      return {
        examId:'',
        examInfo: '',
        questionList: [],
        questionList2: [],
        startTime:'',
        testTime: 0,
        testTimeTxt:'',
        examTime: 0,
        auto:{},
        onlineExamUserId: '',
        testStartTime: '',
        testEndTime: '',
        page:0,
        total:0,
        pageSize:3,
        totalPage:0,
        isLimitIp:false
      }
    },

    mounted() {
      this.examId = this.$route.query.examId
      this.examTime = this.$route.query.examTime*60
      this.onlineExamUserId = this.$route.query.onlineExamUserId
      this.testStartTime = Date()
      this.findAllData()
      let that = this
      this.auto = setInterval(()=>{
        that.testTimeTxt = that.timeToTxt(that.examTime)
        that.examTime--
        if (that.examTime <= 0){
          that.submitExam()
        }
        that.testTime++
      },1000)
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    methods:{
      // 修改 aesDecryptFromBase64 函数中的填充方式
      aesDecryptFromBase64(data, key) {
        try {
          const iv = data.split(":")[0]
          const encryptedData = data.split(":")[1]

          const parsedKey = CryptoJS.enc.Utf8.parse(key)
          const parsedIv = CryptoJS.enc.Base64.parse(iv)

          // 将Base64字符串转换为CipherParams对象
          const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(encryptedData)
          })

          const decrypted = CryptoJS.AES.decrypt(cipherParams, parsedKey, {
            iv: parsedIv,
            mode: CryptoJS.mode.CBC,
            // 如果服务端使用 PKCS5 填充，这里仍然使用 Pkcs7（因为 CryptoJS 中的实现）
            padding: CryptoJS.pad.Pkcs7
          })

          return decrypted.toString(CryptoJS.enc.Utf8)
        } catch (error) {
          console.error('AES解密失败:', error)
          return null
        }
      }
      ,
      meuns(id){
         let that = this
         if(id%this.pageSize == 0){
          this.page = id/this.pageSize
         }else{
          this.page = parseInt(id/this.pageSize)+1
         }
         this.questionList2 = []
          var end = this.page*that.pageSize
          if(end>that.total){
            end = that.total
          }
          var start = (that.page-1)*that.pageSize
          for(let i =start;i<end;i++){
            if(that.questionList.length >0) {
              that.questionList2.push(that.questionList[i]);
              if (that.questionList[i].questionType == 1) {
                if (that.questionList[i].answerList.length == 0) {
                  let panduanAnswerList = []
                  panduanAnswerList.push({
                    'optionName': 'T',
                    'showName': '对',
                    'answerContent': '正确',
                    'selected': false
                  })
                  panduanAnswerList.push({
                    'optionName': 'F',
                    'showName': '错',
                    'answerContent': '错误',
                    'selected': false
                  }),
                    that.questionList2[i - start].answerList = panduanAnswerList
                }
              }
            }
          }
      },
      findAllData(){
        var params = {
          examId:this.examId,
          userId: this.user.userId
        }
        let url = '/api/onlineExam/findOnlineExamPaperEncPC'
        let that = this
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          that.isLimitIp = true
          const result = that.aesDecryptFromBase64(res.data, "TNZox5yYBG3suW+GnmfGVydXGGFQwiBl")
          that.examInfo = JSON.parse(result)
          that.questionList = JSON.parse(JSON.stringify(that.examInfo.questionList))
          that.total= that.questionList.length;
          if(that.total%that.pageSize == 0){
            that.totalPage = parseInt(that.total/that.pageSize);
          }else{
            that.totalPage = parseInt(that.total/that.pageSize) + 1;
          }
          that.page = 1
          var end = that.pageSize
          if(that.questionList.length < end){
            end = that.questionList.length
          }
          for(let i =0;i<end;i++){
            if(that.questionList.length >0){
              that.questionList2.push(that.questionList[i]);
              if (that.questionList[i].questionType == 1){
                if(that.questionList[i].answerList.length == 0){
                  let panduanAnswerList = []
                  panduanAnswerList.push({'optionName':'T','showName': '对','answerContent':'正确','selected':false})
                  panduanAnswerList.push({'optionName':'F','showName': '错','answerContent':'错误','selected':false}),
                    that.questionList2[i].answerList = panduanAnswerList
                }
              }
            }
          }
        }))
      },
      toChooseAnswer(question,answer,index){
        if (question.questionType == 3){
          answer.selected = !answer.selected
          let count = 0

          for (let i=0;i<question.answerList.length;i++){
             if(question.answerList[i].selected){
               count = count+1
             }
          }
          if (count>0){
            question.answered = true
          }else {
            question.answered = false
          }
        }else {
          for (let i=0;i<question.answerList.length;i++){
            question.answerList[i].selected = false
          }
          answer.selected = true
          this.questionList[(this.page-1)*this.pageSize + index].answered = true
        }

        this.$forceUpdate();
      },
      timeToTxt(second){
        let minutes = parseInt(second / 60);//转换分钟
        let minutesString = minutes<10?"0"+minutes:minutes+"";
        second = second % 60;//剩余秒数
        let secondString = second<10?"0"+second:second+"";
        return minutesString+"分"+secondString+"秒";
      },
      clickSubmit(){
        let that = this
        viewFunction.confirmMessageBox(this,'是否交卷？',function () {
          that.submitExam()
        })
      },
      clickPre(){
        let that = this
        if(that.page <= 1){
          this.$message.error('已经是第一页');
        }else{
          that.page = that.page - 1
          that.questionList2 = []
          var end = that.page*that.pageSize
          if(end>that.total){
            end = that.total
          }
          var start = (that.page-1)*that.pageSize
          for(let i =start;i<end;i++){
            if(that.questionList.length >0) {
              that.questionList2.push(that.questionList[i]);
              if (that.questionList[i].questionType == 1) {
                if (that.questionList[i].answerList.length == 0) {
                  let panduanAnswerList = []
                  panduanAnswerList.push({
                    'optionName': 'T',
                    'showName': '对',
                    'answerContent': '正确',
                    'selected': false
                  })
                  panduanAnswerList.push({
                    'optionName': 'F',
                    'showName': '错',
                    'answerContent': '错误',
                    'selected': false
                  }),
                    that.questionList2[i - start].answerList = panduanAnswerList
                }
              }
            }
          }
        }
      },
      clickNext(){
        let that = this
        if(that.page >= that.totalPage){
          this.$message.error('已经是最后一页');
        }else{
          that.questionList2 = []
          var end = (that.page+1)*that.pageSize
          if(end>that.total){
            end = that.total
          }
          var start = that.page*that.pageSize
          for(let i =start;i<end;i++){
            if(that.questionList.length >0) {
              that.questionList2.push(that.questionList[i]);
              if (that.questionList[i].questionType == 1) {
                if (that.questionList[i].answerList.length == 0) {
                  let panduanAnswerList = []
                  panduanAnswerList.push({
                    'optionName': 'T',
                    'showName': '对',
                    'answerContent': '正确',
                    'selected': false
                  })
                  panduanAnswerList.push({
                    'optionName': 'F',
                    'showName': '错',
                    'answerContent': '错误',
                    'selected': false
                  })
                  that.questionList2[i - start].answerList = panduanAnswerList
                }
              }
            }
          }
          that.page = that.page + 1
        }
      },
      submitExam(){
        clearInterval(this.auto)
        let correct = 0;
        let uncorrect = 0;
        let unanswer = 0;
        let correctScore = 0;
        let that = this
        let size = that.questionList.length;
        for (let i=0;i<size;i++){
          let question = that.questionList[i]
          let selectedAnswer = ''

          let answerSize = question.answerList.length
          for (let j=0;j<answerSize;j++){
            let answer = question.answerList[j]
            if (answer.selected){
              selectedAnswer = selectedAnswer+answer.optionName
            }
          }
          question.userAnswer = selectedAnswer
          if (selectedAnswer == ''){
            unanswer++
          }else if (selectedAnswer == question.solution){
            correct++
            correctScore+= question.soreValue
          }else {
            uncorrect++
          }
        }

        this.examInfo.total = this.questionList.length
        this.examInfo.correct = correct
        this.examInfo.uncorrect = uncorrect
        this.examInfo.unanswer = unanswer
        this.examInfo.testTimes = this.testTime
        this.examInfo.questionList = that.questionList
        let url = '/api/onlineExam/submitOnlineExamPCPaper'
        let params = {
          onlineExamUserId: parseInt(this.onlineExamUserId),
          testStartTimeString:moment(this.testStartTime).format("YYYY-MM-DD HH:mm:ss"),
          testEndTimeString:moment(Date()).format("YYYY-MM-DD HH:mm:ss"),
          examPaperRedisDto:this.examInfo,
          correctScore:correctScore
        }
        that.axios.post(url,params).then(res=>viewFunction.handlerRes(that,res,function () {
          that.$message.success('交卷成功')
          that.$router.go(-1)
        }))

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/Examing.vue